import React, { useState } from "react";
import salesDood2 from "../utils/topline_logo.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function MachineRegistration() {


    const navigate = useNavigate()
    const [companyCode, setCompanyCode] = useState("")
    const [publicKey, setPublicKey] = useState("")
    const [privateKey, setPrivateKey] = useState("")

    const [publicKeyErrorMessage, setPublicKeyErrorMessage] = useState("")
    const [privateKeyErrorMessage, setPrivateKeyErrorMessage] = useState("")

    const handleCompanyCode = (e) => {

        setCompanyCode(e.target.value)
        setPublicKeyErrorMessage("")
    }

    const handlePrivateKey = (e)=>{

        // This removes ALL spaces instantly (front, back, and middle)
    const cleanValue = e.target.value.replace(/\s/g, '');

        setPrivateKey(cleanValue)
        setPrivateKeyErrorMessage("")

    }

    const registerMachine = () => {
        const url = `https://cubixweberp.com:199/CheckStatus?cmpcode=${companyCode}&publick=${publicKey}&privatek=${privateKey}`;
        console.log(url);

        axios.get(url).then((res) => {

            if (res) {
                if (res.data?.length > 0) {
                    if (res.data[0].Column1 === 'REGISTERED') {
                        localStorage.setItem("companyCode", companyCode)
                        localStorage.setItem("companyPublicKey", publicKey)
                        localStorage.setItem("companyPrivateKey", privateKey)
                        localStorage.setItem("masterCompanyCode", companyCode);
                        navigate('/');
                    } else {
                        setPrivateKeyErrorMessage("Invalid License Number")
                    }

                } else {
                    setPrivateKeyErrorMessage("Invalid License Number")
                }

            }

        }).catch((err) => {
            console.log("err", err)
        })

    }


    const handleGetPubKey = (e) => {


        if (companyCode?.length > 0) {

            const url = `https://cubixweberp.com:199/GetPublicKey?cmpcode=${companyCode}`;

            console.log(url);

            axios.get(url).then(res => {
                console.log('Raw Response:', res);
                if (res) {
                    if (res.data?.length > 0) {

                        setPublicKey(res.data[0].systemkey)
                        setPublicKeyErrorMessage("")
                    } else {
                        setPublicKeyErrorMessage('invalid company code')
                    }

                } else {
                    setPublicKeyErrorMessage('invalid company code')
                }
            })
                .catch(error => {
                    console.error('Error:', error);

                });
        }
        else {
            alert("Please enter company code")
        }
    };

    return (
        <div className="p-4">

            <div>
                <img
                    src={salesDood2}
                    alt="Salesdood"
                    className="rounded  w-auto h-16 text-xl text-black font-semibold cursor-pointer "
                />
            </div>

            <h1 className="mt-4" style={{ fontSize: 20 }}>Device Registration</h1>

            <p className="mt-4" style={{ color: "#2f4f4f", fontSize: "18px", fontWeight: 300 }}>To use TOPLINE360 in this device, please register. Enter your company code and Generate Key. Give the generated key to your company admin for license number </p>


            <p className="mt-4">Please enter company code</p>
            <input onChange={(e) => handleCompanyCode(e)}></input>
            <div className="mt-2">
                <button className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800" onClick={(e) => handleGetPubKey(e)}>Generate Key</button>
            </div>

            {publicKey &&
                <p style={{ fontSize: 24 }}>{publicKey}</p>
            }

            {publicKeyErrorMessage?.length > 0 &&
                <p style={{ color: "#f00" }}>{publicKeyErrorMessage}</p>
            }

            <p className="mt-4" >Enter License number</p>
            <input onChange={(e)=>handlePrivateKey(e)}></input>
            {
                privateKeyErrorMessage?.length > 0 &&
                <p style={{color:"#f00"}}>{privateKeyErrorMessage}</p>
            }
            <div className="mt-2">
                <button onClick={() => registerMachine()} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Register device</button>
            </div>

        </div>
    )

}

export default MachineRegistration